module.exports = __webpack_public_path__ + "/img/DIP-Labeled-MUreZi.svg";